/**
 * @generated SignedSource<<070ab5de63dc5c6eb5607f3d7df95f2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarketingEmailStatus = "DRAFT" | "PARTIALLY_SENT" | "SENDING" | "SENT" | "%future added value";
export type CreateMarketingEmailInput = {
  name: string;
};
export type CreateMarketingEmailDialogMutation$variables = {
  input: CreateMarketingEmailInput;
};
export type CreateMarketingEmailDialogMutation$data = {
  readonly createMarketingEmail: {
    readonly id: string;
    readonly marketingEmailIdentifier: string;
    readonly name: string;
    readonly status: MarketingEmailStatus;
  };
};
export type CreateMarketingEmailDialogMutation = {
  response: CreateMarketingEmailDialogMutation$data;
  variables: CreateMarketingEmailDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarketingEmail",
    "kind": "LinkedField",
    "name": "createMarketingEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingEmailIdentifier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateMarketingEmailDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateMarketingEmailDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "44879ad34c3dad217a20a407c0094e65",
    "id": null,
    "metadata": {},
    "name": "CreateMarketingEmailDialogMutation",
    "operationKind": "mutation",
    "text": "mutation CreateMarketingEmailDialogMutation(\n  $input: CreateMarketingEmailInput!\n) {\n  createMarketingEmail(input: $input) {\n    id\n    marketingEmailIdentifier\n    name\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f0105d9aa925517bf874bdf0611522f";

export default node;
